<form [formGroup]="immediateContactDetailsForm">

  <p-panel class="panel-padding" [toggleable]="false"
    header="Immediate Contact Details" data-test-id="immidiate-contact-details">

    <div class="col-span-12">
      <p class="mt-4 mb-6" data-test-id="immidiate-contact-header">
        Please provide the  contact information for a Carelon representative to reach out to you or a delegate, if necessary.
      </p>
    </div>

    <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
      <div class="col-span-12 lg:col-span-6">
        <div class="field">
          <label data-test-id="contact-name"><span [class]="{ 'field-required': isExternalUser }"></span>Contact Name:</label>
          <div class="p-field-value">
            <input type="text"
              pInputText
              formControlName="contactName"
              data-test-id="contact-name-value"/>
            </div>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-3">
          <div class="field">
            <label data-test-id="contact-phone"><span [class]="{ 'field-required': isExternalUser }"></span>Contact Phone:</label>
            <div class="p-field-value">
              <p-input-mask class="w-full"
                mask="(999) 999-9999"
                formControlName="phone"
                [unmask]="true"
                [autoClear]="false"
                data-test-id="contact-phone-value">
              </p-input-mask>
            </div>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-3">
        </div>
        <div class="lg:col-span-3">
          <div class="field">
            <label data-test-id="contact-fax"><span [class]="{ 'field-required': isExternalUser }"></span>Contact Fax:</label>
            <div class="p-field-value">
              <p-input-mask class="w-full"
                mask="(999) 999-9999"
                formControlName="fax"
                [unmask]="true"
                [autoClear]="false"
                data-test-id="contact-fax-value">
              </p-input-mask>
            </div>
          </div>
        </div>
        <!--<div class="warn-message mt-4">
        <i aria-hidden="true" class="pi pi-exclamation-triangle"></i>

      </div>-->

      <div class="lg:col-span-3">
      </div>
      <div class="col-span-6 lg:col-span-3">

        <div class="field">
          <label data-test-id="contact-phone-extension"><span></span>Contact Phone Extension:</label>
          <div class="p-field-value">
            <input type="text"
              pInputText
              formControlName="phoneExt"
              maxlength="9"
              data-test-id="contact-phone-extension-value" />
            </div>
          </div>
        </div>
        <div class="lg:col-span-3">
        </div>
      </div>

      <div class="lg:w-1/2" data-test-id="fax-numbers-warning">
        <p-message severity="warn" icon="pi pi-exclamation-triangle">
          Fax numbers submitted here will be used to send PHI, authorizations, and clinical requests.
        </p-message>
      </div>

      @if (isExternalUser) {
        <div>
          <div class="flex items-center">
            <p-checkbox
              inputId="contactFaxConfirmedCheck"
              formControlName="contactFaxConfirmed"
              [binary]="true"
            ></p-checkbox>
            <label for="contactFaxConfirmedCheck" class="ml-2 font-semibold">I confirm that the Contact Fax is verified</label>
          </div>
        </div>
      }
    </p-panel>

  </form>
